import React from 'react';

import { HEIGHT_ITEM } from '../../../const';
import { ItemType } from '../../../types';
import GantLeftHeaderBoxItemArrowCollapse from '../../gantLeftHeaderBoxItemArrowCollaps';

export const ProjectsTreeExpandIcon: React.FC<{ item: ItemType }> = ({ item }) => {
    return (
        <svg width={25} height={HEIGHT_ITEM}>
            <g transform={'translate(6, 0)'}>
                <GantLeftHeaderBoxItemArrowCollapse item={item} offsetX={20} isCircleHidden cursorAreaOffset={-6} />
            </g>
        </svg>
    );
};
